export default [{
  name: 'orderDetail',
  method: 'get',
  desc: '获取机票订单详情',
  path: '/obt/orderDetail',
  params: {
    id: ''
  }
},
{ // /obt/yyzx/airlineJoin/findByAirline  通过航司查询入会信息
  name: 'findByAirline',
  method: 'post',
  desc: '通过航司查询入会信息',
  path: '/obt/yyzx/airlineJoin/findByAirline',
  params: {
    airline: ''
  }
},
{
  name: 'moreRefundInfo',
  method: 'get',
  desc: '根据正常单ID获取机票退票订单详情',
  path: '/obt/moreRefundInfo',
  params: {
    orderId: ''
  }
},{
  name: 'findChangeOrderByOrderId',
  method: 'get',
  desc: '根据订单id获取改签单',
  path: '/obt/findChangeOrderByOrderId',
  params: {
    orderId: ''
  }
},{
  name: 'cancelTkOrder',
  method: 'post',
  desc: '取消机票正常订单',
  path: '/obt/cancelTkOrder',
  params: {
    orderId: ''
  }
},{
  name: 'findChangeOrderByChangeId',
  method: 'get',
  desc: '获取改签后 航程',
  path: '/obt/findChangeOrderByChangeId',
  params: {
    changeId: ''
  }
},


/*****退票****/
{
  name: 'applyRefund',
  method: 'get',
  desc: '获取机票可退票订单详',
  path: '/obt/applyRefund',
  params: {
    orderId: ''
  }
},{
  name: 'refundAdd',
  method: 'post',
  desc: '机票退票提交',
  path: '/obt/refundAdd',
  params: {
    'orderFrom': '',
    'orderId': '',
    'psgIdList': '',
    'rangeIdList': '',
    'refundProveUrl': '',
    'refundReasonVip': '-',
    'refundResaon': '',
    'refundType': 0,
    'refundApplyRemark':''
  }
},{
  name: 'refundCancel',
  method: 'get',
  desc: '取消机票退票',
  path: '/obt/refundCancel',
  params: {
    refundOrderId:''
  }
},{
  name: 'refundOrderDetail',
  method: 'get',
  desc: '机票退票详情',
  path: '/obt/refundOrderDetail',
  params: {
    refundId:''
  }
},

/*****改签****/
{
  name: 'applyTkChange',
  method: 'get',
  desc: '获取机票可改签订单详',
  path: '/obt/applyTkChange',
  params: {
    orderId: ''
  }
},{
  name: 'tkChangeOrderAdd',
  method: 'post',
  desc: '提交机票改签单',
  path: '/obt/tkChangeOrderAdd',
  params: {
    'alterType': 0,
    'changeProveUrl': '',
    'changeReason': '',
    'changeReasonCode': '',
    'changeReasonCodeVip': '',
    'changeReasonVip': '',
    'changeType': '',
    'orderFrom': '',
    'orderId': '',
    'psgIds': '',
    'changeApplyRemark':'',
    'ranges': [
      // {
      // "cabinKey": "",
      // "cacheId": "",
      // "nCabin": "",
      // "nDepartTime": "",
      // "nFlightNo": "",
      // "nShareFlightNo": "",
      // "nStopAirport": "",
      // "nStopArriveTime": "",
      // "nStopDepartTime": "",
      // "rangeId": ""
      // }
    ]
  }
},{
  name: 'cancelChangeOrder',
  method: 'get',
  desc: '取消机票改签订单',
  path: '/obt/cancelChangeOrder',
  params: {
    changeId: ''
  }
},{
  name: 'tkChangeOrderDetail',
  method: 'get',
  desc: '获取机票改签订单详情',
  path: '/obt/tkChangeOrderDetail',
  params: {
    changeOrderId: ''
  }
},{
  name: 'tkChangeQueryFlight',
  method: 'post',
  desc: '获取航班列表',
  path: '/obt/tkChangeQueryFlight',
  params: {
    'alterType': 1,//改签类别1改期2升舱
    'arriveAirport': '',
    'departAirport': '',
    'departDate': '',
    'orderId': '',
    'rangeId': ''//改签航段id 升舱时必传
  }
},{
  name: 'tkChangeQueryFee',
  method: 'post',
  desc: '获取改期费',
  path: '/obt/tkChangeQueryFee',
  params: {
    'newPnr': '',//新PNR
    'tknos': '',//原票号
    'plane': '',// 机型
  }
},{
  name: 'tkChangeV3QueryFlight',
  method: 'post',
  desc: '获取航班列表',
  path: '/obt/tkChangeV3QueryFlight',
  params: {
    'alterType': 1,//改签类别1改期2升舱
    'arriveAirport': '',
    'departAirport': '',
    'departDate': '',
    'orderId': '',
    'rangeId': ''//改签航段id 升舱时必传
  }
},{
  name: 'tkChangeV3QueryFlightPrice',
  method: 'post',
  desc: '获取航班列表',
  path: '/obt/tkChangeV3QueryFlightPrice',
  params: {
    'cacheId': '',
    'flightNo': '',
    'tripType': '',

  }
},{
  name: 'matchNowFlightRule',
  method: 'post',
  desc: '机票查询当前退改签金额或百分比',
  path: '/obt/matchNowFlightRule',
  params: {
    'orderId': '',
    'psgBeanList': [
      // {
      // "psgId": "",
      // "rangeIds": ''
      // }
    ],
    'operFlag': ''//1 退票 2改签
  }
},{
  name: 'getScheduleOrder',
  method: 'post',
  desc: '日程订单查询',
  path: '/obt/plane/tkOrder/scheduleOrder',
  params: {
    findScope: 1,
    pageNum: null,
    count: null
  },
  loading:'0'
},
{
  name: 'findInfo',
  method: 'post',
  desc: '日程订单查询',
  path: '/oss/vipCorp/compCorpImg/findInfo',
  params: {
    corpId:'',
    compId:'',
    from:2
	
  },
  loading:'0'
}

]
